import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { AnimatePresence, motion } from "framer-motion";
// Components
import Heading from "../../elements/heading";
import PrimaryButton from "../../elements/primary-button";
import CartItem from "../../sections/cart-item";
import EmptyCartMessage from "../../sections/empty-cart-message";
import LoadingSpinner from "../../elements/loading-spinner";

// Styles
import "./style.scss";
// Animations
import { containerCartAnimations, childCartAnimations, checkoutAnimations } from "./animations";
import { canUseDOM } from "../../utils";

const CartPreview = ({ heading, cartItems = [], total, button, active, message = "CART IS EMPTY", onClickOutside = () => {}, onItemClick = () => {}, isLoading }) => {
  const match = canUseDOM() && window?.location?.pathname.split("/").length ? { params: { lang: window.location.pathname.split("/")[1] } } : { params: { lang: "" } };
  useEffect(() => {
    const header = document.querySelector("header.header");
    header &&
      header.addEventListener("click", () => {
        onClickOutside();
      });
    return (
      header &&
      header.removeEventListener("click", () => {
        onClickOutside();
      })
    );
  }, []);
  return (
    <AnimatePresence>
      {active && (
        <div className="cart-preview-container" onClick={onClickOutside}>
          <motion.div
            className="cart-preview"
            variants={containerCartAnimations}
            initial="exit"
            animate="enter"
            exit="exit"
            onClick={event => {
              // Prevent click in cart preview to call onClickOutside
              event.stopPropagation();
            }}
            // onMouseEnter={(event) => {
            //   document.querySelector("body").classList.add("no-scroll");
            // }}
            // onMouseLeave={(event) => {
            //   document.querySelector("body").classList.remove("no-scroll");
            // }}
            onTouchStart={event => {
              document.querySelector("body").classList.add("no-scroll");
            }}
            onTouchEnd={event => {
              document.querySelector("body").classList.remove("no-scroll");
            }}
          >
            <motion.div className="animate" variants={childCartAnimations} exit="exit">
              <Heading {...heading} typographyClass="type-h3" className="cart-preview-heading" />
            </motion.div>

            <div className="cart-items-container">
              <motion.div className="cart-items" variants={childCartAnimations} exit="exit">
                {isLoading && <LoadingSpinner />}

                {cartItems.length
                  ? cartItems.map((product, index) => {
                      var items = [];
                      for (var i = 0; i < product.quantity; i++) {
                        items.push(
                          <CartItem
                            key={`${product.name}-${index}`}
                            {...{
                              ...product,
                              price: product.price,
                              discountedPrice: product.discountedPrice,
                              link: {
                                url: `${product.productPage}${product.productPath}`
                              }
                            }}
                            onClick={onItemClick}
                            match={match}
                          />
                        );
                      }
                      return items;
                    })
                  : !isLoading && (
                      <div className="empty-cart-container">
                        <EmptyCartMessage text={message} />
                      </div>
                    )}
              </motion.div>

              {cartItems.length > 0 && <div className="bottom-fade" />}
            </div>

            <motion.div variants={checkoutAnimations} exit="exit" className="animate">
              <div className="cart-total">
                <div className="cart-total-label">{total.label}</div>
                <div className="cart-total-label">{total.price}</div>
              </div>
              <span onClick={onClickOutside}>
                <PrimaryButton {...button} />
              </span>
            </motion.div>
          </motion.div>
        </div>
      )}
    </AnimatePresence>
  );
};

CartPreview.propTypes = {
  heading: PropTypes.object,
  message: PropTypes.string,
  cartItems: PropTypes.array,
  total: PropTypes.shape({
    label: PropTypes.string,
    price: PropTypes.any,
    currency: PropTypes.string
  }),
  button: PropTypes.object,
  active: PropTypes.bool,
  onClickOutside: PropTypes.func,
  onItemClick: PropTypes.func,
  isLoading: PropTypes.bool
};

export default CartPreview;
